import { createSelector, MemoizedSelector, createFeatureSelector } from '@ngrx/store';

import { SirenResponse } from '@awp/http';
import { DataState } from './state';
import { Dictionary } from '@awp/core/utils';

export const dataFeatureName = 'data';

export const dataFeatureState: MemoizedSelector<object, DataState> = createFeatureSelector<DataState>(dataFeatureName);

export const getSirenResponses: MemoizedSelector<object, { [key: string]: SirenResponse }> =
  createSelector(dataFeatureState, (state: DataState): Dictionary<SirenResponse> => state.responses);

export const getSirenResponse = <T>(name: string): MemoizedSelector<DataState, T> => createSelector(getSirenResponses, responses => responses[name] as T);